import React, { useCallback } from "react";
import { toast } from "react-hot-toast";
import AlertIcon from "components/icons/bold/alert.svg?react";
import CircleCheckIcon from "components/icons/bold/circle-check.svg?react";
import CircleXIcon from "components/icons/bold/circle-x.svg?react";
import InfoIcon from "components/icons/bold/info.svg?react";
import CloseIcon from "components/icons/linear/x.svg?react";
import { Button } from "components/buttons/Button";
import "./Notification.scss";

export type FlagVariant = "default" | "success" | "error" | "warning" | "info";

type TBtn = {
  title: string;
  onClick: () => void;
}

export interface INotificationProps {
  id: string;
  title: string;
  description?: string;
  variant: FlagVariant;
  actionButton?: TBtn;
  secondaryButton?: TBtn;
}

const variantIconMapping: Record<FlagVariant, JSX.Element> = {
  default: <CircleCheckIcon data-testid="icon-default" />,
  success: <CircleCheckIcon data-testid="icon-success" />,
  error: <CircleXIcon data-testid="icon-error" />,
  warning: <AlertIcon data-testid="icon-warning" />,
  info: <InfoIcon data-testid="icon-info" />,
};

export const Notification: React.FC<INotificationProps> = ({
  title,
  id,
  description,
  variant,
  actionButton,
  secondaryButton
}) => {
  const Icon = variantIconMapping[variant];

  const onButtonClick = useCallback((button?: TBtn) => {
    toast.dismiss(id);
    button?.onClick();
  }, [id]);

  return (
    <div className={`Notification Notification_${variant}`}>
      <div className="Notification-Default">
        <span className="Notification-Icon">{Icon}</span>
        <span className="Notification-Title">{title}</span>
        <button className="Notification-Close" onClick={() => toast.remove(id)} aria-label="Close notification"><CloseIcon /></button>
      </div>
      {description && <p className="Notification-Description">{description}</p>}
      <div className="Notification-Footer">
        {secondaryButton && <button className="Notification-SecBtn" onClick={() => onButtonClick(secondaryButton)}>{secondaryButton.title}</button>}
        {actionButton && <Button variant="secondary" size="xs" onClick={() => onButtonClick(actionButton)} aria-label={actionButton.title}>{actionButton.title}</Button>}
      </div>
    </div>
  );
};

